const primary = {
  primary: '#D14242',
  hover: '#DE4C47',
  active: '#AB2E32',
  background: '#FFF2F0',
  border: '#F7A79E'
};
const neutral = {
  grey100: '#242C34',
  grey90: '#2D3742',
  grey80: '#242C34',
  grey70: '#5E6C84',
  grey60: '#7A869A',
  grey50: '#A5ADBA',
  grey40: '#B3BAC5',
  grey30: '#DFE1E6',
  grey20: '#EBECF0',
  grey10: '#F4F5F7',
  grey05: '#FBFBFB',
  white: '#FFFFFF',
  loading: '#E3E3E3',
  gradientLoading: 'linear-gradient(90deg, #F0EEEE 0%, #E3E3E3 100%);'
};
const error = {
  primary: '#E53935',
  hover: '#F44336',
  background: '#EF9A9A',
  active: '#D32F2F'
};
const warning = {
  primary: '#FFB300',
  hover: '#FFC107',
  background: '#FFECB3',
  active: '#FFA000'
};
const success = {
  primary: '#43A047',
  hover: '#4CAF50',
  background: '#A5D6A7',
  active: '#388E3C'
};
const info = {
  primary: '#039BE5',
  hover: '#03A9F4',
  background: '#81D4FA',
  active: '#0288D1'
};
export { primary, neutral, error, warning, success, info };
export default {
  primaryTextColor: neutral.grey100,
  secondaryTextColor: neutral.grey70,
  placeholderTextColor: neutral.grey50,
  disabledTextColor: neutral.grey40,
  disabledColor: neutral.grey30,
  borderColor: neutral.grey20,
  backgroundColor: neutral.grey10,
  primary,
  neutral,
  error,
  warning,
  success,
  info
};